import React from 'react'

export default function ImageContainer({src}) {
  return (
    <div>
        <img src={src} className='w-full max-h-160'/>
    </div>
  )
}